/**
 * Where a member's announcement opt-out came from. Mirrors the backend enum
 * (PascalCase on the wire).
 */
export enum AnnouncementOptOutSource {
  UnsubscribeLink = "UnsubscribeLink",
  MemberPortal = "MemberPortal",
  /** The member withdrew their marketing consent on the portal's Me page. */
  ConsentWithdrawal = "ConsentWithdrawal",
}
